import { LicenseManagementUserGroupIdServices } from './[id]'

export const LicenseManagementUserGroupsServices = {
  id: LicenseManagementUserGroupIdServices
}
